/** 停止单张灵感卡片悬停预览视频（含 pending canplay 与音频） */
export function stopInspirationHoverVideo(vid) {
  if (!vid || vid.tagName !== 'VIDEO') return

  if (vid._hoverPlayHandler) {
    vid.removeEventListener('canplay', vid._hoverPlayHandler)
    vid._hoverPlayHandler = null
  }

  try {
    vid.pause()
  } catch (_) {
    /* ignore */
  }
  vid.muted = true
  vid.currentTime = 0
  vid.removeAttribute('src')
  delete vid.dataset.loadedUrl
  try {
    vid.load()
  } catch (_) {
    /* ignore */
  }

  vid.classList.remove('ip-card-video--playing')
  const media = vid.closest('.ip-hcard-media, .ip-mcard-media')
  const playIcon = media?.querySelector('.ip-hcard-play-icon, .ip-mcard-play-icon')
  if (playIcon) playIcon.style.opacity = ''
}

/** 停止组件内全部灵感卡片悬停预览视频 */
export function stopAllInspirationHoverVideos(root) {
  const el = root && root.$el ? root.$el : root
  if (!el || typeof el.querySelectorAll !== 'function') return
  el.querySelectorAll('.ip-hcard-video, .ip-mcard-video').forEach(stopInspirationHoverVideo)
}

/** 停止灵感详情弹窗中的视频（若已挂载） */
export function stopInspirationDetailModalVideos(modal) {
  if (!modal) return
  if (typeof modal.stopDetailVideo === 'function') modal.stopDetailVideo()
  if (typeof modal.clearSampleVideos === 'function') modal.clearSampleVideos()
}
